var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button-slot" }, [
    _c("a", { staticClass: "link", attrs: { href: _vm.urlProp } }, [
      _vm.iconProp == "heart"
        ? _c(
            "svg",
            {
              staticClass: "icon",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16.7 15.3"
              }
            },
            [
              _c("path", {
                attrs: {
                  fill: "#e30613",
                  d:
                    "M4.4 1.4c2.2 0 3.4 2.4 4 3.5.5-1 1.7-3.5 4-3.5a2.8 2.8 0 0 1 3 3c0 2.3-3.4 5.4-7 9-3.7-3.6-7-6.7-7-9.1a2.8 2.8 0 0 1 3-2.9Zm0-1.4A4.2 4.2 0 0 0 0 4.3c0 3.3 3.9 6.6 8.4 11 4.4-4.4 8.3-7.7 8.3-11A4.2 4.2 0 0 0 12.3 0a4.5 4.5 0 0 0-4 2.3 4.5 4.5 0 0 0-4-2.3Z"
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.iconProp == "file"
        ? _c(
            "svg",
            {
              staticClass: "icon",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24"
              }
            },
            [
              _c("path", {
                attrs: {
                  fill: "#e30613",
                  d: "M15 2v5h5v15h-16v-20h11zm1-2h-14v24h20v-18l-6-6z"
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v("\n\t\t" + _vm._s(_vm.labelProp) + "\n\t")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }